import { REGION_MASTER_ROUTE } from "config/route-consts";
import { ProtectedRoute } from "pages/Authentication/ProtectedRoute";
import React from "react";
import { Switch } from "react-router-dom";
import { authorizationService } from "services/common-services/authorization-service";
import RegionMaster from "./RegionMaster/RegionMaster";

function RegionView() {
  const { auth } = authorizationService.useAuthorizedRoute();
  return (
    <Switch>
      <ProtectedRoute
        path={REGION_MASTER_ROUTE}
        key={REGION_MASTER_ROUTE}
        component={RegionMaster}
        auth={auth(REGION_MASTER_ROUTE)}
      />
    </Switch>
  );
}

export { RegionMaster };
export default RegionView;
